import API from '@/api/api.js'

export default class DwAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }

  getCustomerReport(params, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/customer', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getPerformanceReport(params, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/performance', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getSaleReport(params, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/sale', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getRenewalReport(params, success, error) {
    this.api.get('/report/renewal', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getCommissionReport(params, success, error) {
    this.api.get('/commission', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  getFormList(params, success, error) {
    this.api.get('/dm/form', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  getFormDetail(param, success, error) {
    // console.log(param);
    this.api.get('/dm/form/detail', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  createForm(param, success, error) {
    this.api.post('/dm/form/create', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editForm(param, success, error) {
    this.api.post('/dm/form/edit', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deleteForm(param, success, error) {
    this.api.post('/dm/form/delete', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getAgentCommissionReport(param, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/commission', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getCompanyCommissionReport(param, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/policyCommission', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getRenewalReport(param, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/renewal', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getGiPolicyReport(param, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/giPolicy', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getLifePolicyReport(param, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/lifePolicy', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getClaimReport(param, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/claim', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

  getSrReport(param, success, error, parseTypeEnum, responseType = {}) {
    this.api.get('/report/serviceRequest', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, parseTypeEnum, responseType)
  }

}



// WEBPACK FOOTER //
// ./src/api/Dw/apiList.js